import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { head } from 'es-toolkit';
import { UnauthQueryOptions } from '@/api';
export const usePhotoReviewEvent = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home-donation-event"]({
        query: {
          eventCode: "PHOTO_REVIEW_1000"
        }
      }),
      select: _temp,
      staleTime: 0,
      gcTime: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: photoReviewEventData,
    isLoading: isPhotoReviewEventProgressingLoading
  } = useQuery(t0);
  const isEventProcess = photoReviewEventData?.inProgress ?? false;
  let t1;
  if ($[1] !== isEventProcess || $[2] !== photoReviewEventData) {
    t1 = donationAmount => {
      if (!isEventProcess) {
        return false;
      }
      if (!donationAmount) {
        return false;
      }
      if (!photoReviewEventData?.eventConditionDto?.minDonationAmount) {
        return false;
      }
      return photoReviewEventData.eventConditionDto.minDonationAmount <= donationAmount;
    };
    $[1] = isEventProcess;
    $[2] = photoReviewEventData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const checkPossibleEvent = t1;
  let t2;
  if ($[4] !== checkPossibleEvent || $[5] !== isEventProcess || $[6] !== isPhotoReviewEventProgressingLoading) {
    t2 = {
      isEventProcess,
      checkPossibleEvent,
      isLoading: isPhotoReviewEventProgressingLoading
    };
    $[4] = checkPossibleEvent;
    $[5] = isEventProcess;
    $[6] = isPhotoReviewEventProgressingLoading;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
function _temp(data) {
  return head(data.context?.contents ?? []);
}